import React, {Component, useEffect} from 'react';
import Router from "next/router";
import {ThemeProvider} from 'styled-components';
import {ToastContainer} from 'react-toastify';
import BaseProviders from "@providers/base";
import BrandBulletLoading from "@atoms/brand.bullet.loading";
import {isEmpty} from "@helpers/helpers";

import 'react-toastify/dist/ReactToastify.css';
import '@assets/scss/base.scss';
import {checkLocalStorageExpiration} from "../helpers/storage_manage";
import {swConfig} from "../helpers/sw_config";
import {weAreHiringAlert} from "../components/helpers/hiring_alert";


const theme = require('sass-extract-loader?{"plugins":["sass-extract-js"]}!./../assets/scss/bootstrap/base_variables.scss');

// init();
var oldStartUrl = '';
var routeChange = false;

function MyApp(props) {
    const {Component, pageProps} = props;

    React.useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }

        checkLocalStorageExpiration();
    }, []);

    useEffect(() => {
        const handleStart = (url) => {

            if (url !== oldStartUrl) {
                oldStartUrl = url;
                routeChange = true;
            }

            if (url !== Router.asPath) {
                document.querySelector('.bullet-loading').classList.add('show-bullet-loading');
            }
        };

        const handleComplete = url => {
            if (url === Router.asPath) {
                document.querySelector('.bullet-loading').classList.remove('show-bullet-loading');
            }

            if (routeChange) {
                routeChange = false;

                if (!isEmpty(window.dataLayer)) {
                    window.dataLayer.push({
                        'event': 'virtual-page-view',
                    });
                }
            }
        };

        Router.events.on("routeChangeStart", handleStart);
        Router.events.on("routeChangeComplete", handleComplete);
        Router.events.on("routeChangeError", handleComplete);

        return () => {
            Router.events.off("routeChangeStart", handleStart);
            Router.events.off("routeChangeComplete", handleComplete);
            Router.events.off("routeChangeError", handleComplete);
        };
    });

    React.useEffect(() => {
        if (process.env.NEXT_PUBLIC_APP_ENV !== 'local') {
            swConfig();

            weAreHiringAlert();
        }
    }, []);

    //console.log(process.env.NODE_ENV);

    return (
        <ThemeProvider theme={theme}>
            <BaseProviders>
                <BrandBulletLoading/>

                <Component {...pageProps} err={props.err}/>

                <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    pauseOnHover
                />
            </BaseProviders>
        </ThemeProvider>
    );
}

MyApp.getInitialProps = async ({Component, ctx}) => {
    let defaultCityId = 259;
    let pageProps = {};

    if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(ctx);
    }

    let fingerprint = '';
    if (!isEmpty(ctx.req) && !isEmpty(ctx.req.fingerprint)) {
        fingerprint = ctx.req.fingerprint.hash;

        if (!isEmpty(pageProps)) {
            pageProps['fingerprint'] = fingerprint;

            ctx.res.cookie('fingerprint', fingerprint, {maxAge: 2592000000, httpOnly: false, secure: false, path: '/'}); // 30 day
        }
    }

    return {pageProps};
};

export default MyApp;